<template>
  <div class="container-fluid">
    <card>
      <template slot="header">
        <h3>
          <i class="fad fa-list"></i>
          لیست جلسات
        </h3>
        <hr />
      </template>
      <template slot="content">
        <scrum-session-table :Allsession="false"></scrum-session-table>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import ScrumSessionTable from './Components/ScrumSessionTable.vue'
export default {
  components: { Card, ScrumSessionTable },
  data() {
    return {}
  },
}
</script>
